<template>
	<div id="app">
		{{ stateSync }}
		<router-view />
		<GlobalToast />
	</div>
</template>


<script>
import { getCookieToken } from "./utils/tokenCheck";
import GlobalToast from "./components/Toast.vue";
export default {
	name: "App",
	components: {
		GlobalToast,
	},
	computed: {
		stateSync() {
			let stt = this.$store.state;
			localStorage.setItem("simpAdminState", JSON.stringify(stt));
			return "";
		},
	},
	created() {
		let savedstate = localStorage.getItem("simpAdminState");
		if (savedstate != null) {
			this.$store.replaceState(JSON.parse(savedstate));
		}
		localStorage.setItem("vue_token", getCookieToken());
	},
};
</script>

<style>
</style>
